module.exports = __webpack_public_path__ + "static/img/background.de9b50bf.svg";